import FocusableBackButton from '@components/FocusableBackButton';
import { usePrescriptionContext } from '@context/Prescription';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import DeliverySelection from './components/DeliverySelection';
import ImageSlide from './components/ImageSlide';

import * as styles from './styles';

const PrescriptionView = () => {
  const { treatment, setButtonFocus } = usePrescriptionContext();

  const { focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.rootContainer}>
        <div css={styles.mainContainer}>
          <div css={styles.mainTopContainer}>
            <FocusableBackButton />
            <div css={styles.title}>처방전</div>
          </div>
          <ImageSlide urls={treatment?.prescription?.fileUrls ?? []} />
        </div>
        <div css={styles.rightContainer}>
          <DeliverySelection />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default PrescriptionView;
